import { useState } from 'react';
import { PremiumPaywallSignModes, SiteLinks, SubscriptionPlan, PaywallPlans } from "../../../../global/paywall/paywallInterfaces"
import { LegalLink } from '../mobile/premiumPaywallMobile';
import { PremiumPaywallDesktopSignin } from './premiumPaywallDesktopSignin';
import { getNewWindowOpenTargetProperties } from "widgets/widgetsUtils"
import { PremiumPaywallDesktopSignup } from "./premiumPaywallDesktopSignup"
import { useRedirect } from '../../../../global/paywall/useRedirect';


interface PremiumPaywallDesktopProps {
  setIsRedirecting?: (isRedirect: boolean) => void;
}

export interface PremiumPaywallState {
  mode: PremiumPaywallSignModes;
  isNewspaper?: boolean;
}


declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}



export const PremiumPaywallDesktop = (props: PremiumPaywallDesktopProps) => {
  const [authMode, setAuthMode] = useState<PremiumPaywallState>({
    mode: 'signUp',
    isNewspaper: false,
  });
  const [email, setEmail] = useState<string>('');
  const [agreesTerms, setAgreeTerms] = useState(false);
  const [password, setPassword] = useState('');
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [selectedUrl,setSelectedUrl] = useState<string>('');
  const purchaseUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.purchase : '';
  useRedirect({ fallbackUrl: selectedUrl, enabled: isRedirecting });


  const handleSelectPlan = (selectedPlan: string | null): string => {
    if (!selectedPlan || !purchaseUrl) return '';
    const url = new URL(purchaseUrl, window.location.origin);
    url.searchParams.set('selected', selectedPlan);
    setSelectedUrl(url.toString());
  };



  const getFormByMode = () => {
    if (authMode.mode === 'signUp') {
      return (
        <PremiumPaywallDesktopSignup
          email={email}
          password={password}
          agreesTerms={agreesTerms}
          setEmail={setEmail}
          setPassword={setPassword}
          setAgreesTerms={setAgreeTerms}
          setMode={setAuthMode}
          setIsRedirecting={setIsRedirecting}
          handleSelectPlan={handleSelectPlan}
        />
      );
    }
    return (
      <PremiumPaywallDesktopSignin
        email={email}
        password={password}
        agreesTerms={agreesTerms}
        setEmail={setEmail}
        setPassword={setPassword}
        setAgreesTerms={setAgreeTerms}
        setMode={setAuthMode}
        setIsRedirecting={setIsRedirecting}
        isNewspaper={authMode.isNewspaper}
      />);
  };

  return <div className="premium-paywall-desktop">{getFormByMode()}</div>;
};
